export const translations = {
  'de-DE': {
    translation: {
      showToday: 'Heute anzeigen',
      outOfRange: 'Außerhalb des Bereichs',
      selectUpToDays: 'Datum innerhalb von {maxDays} Tagen auswählen',
      From: 'Von',
      FromToDateRangeError: 'Das Bis-Datum kann nicht vor dem Von-Datum liegen',
      to: 'Bis',
      dateFrom: 'Datum ab',
      loadingError: 'Fehler beim Laden',
      contactAdmin:
        'Aktualisieren Sie die Seite, um die Daten zu laden. Wenden Sie sich an Ihren Administrator, wenn das Problem weiterhin auftritt.',
      searchFor: 'Suchen nach',
      nodes: 'Knoten',
      cancel: 'Abbrechen',
      back: 'Zurück',
      saveAndContinue: 'Speichern und fortfahren',
      yes: 'Ja',
      no: 'Nein',
      selectDateRange: 'Select the date range between {days} days',
      Today: 'I dag',
      Yesterday: 'I går',
      LastWeek: 'Last Week',
      ThisMonth: 'This Month',
      LastMonth: 'Last Month',
      Last3Months: 'Last 3 Months',
      Last6Months: 'Last 6 Months',
      YearToDate: 'Year To Date',
      LastYear: 'Last Year',
      datePickerErrorMsg: 'Please select the dates within {days} months range.',
      datePickerGreaterErrorMessage: 'From Date cannot be greater than To Date',
      Duration: 'Duration',
      To: 'To',
      apply: 'Apply'
    }
  }
};
